import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LyColor } from './color.directive';
var ColorModule = /** @class */ (function () {
    function ColorModule() {
    }
    ColorModule.decorators = [
        { type: NgModule, args: [{
                    imports: [
                        CommonModule
                    ],
                    exports: [LyColor],
                    declarations: [LyColor]
                },] },
    ];
    /** @nocollapse */
    ColorModule.ctorParameters = function () { return []; };
    return ColorModule;
}());
export { ColorModule };
//# sourceMappingURL=color.module.js.map